"use client";

import { c as _c } from "react/compiler-runtime";
import type { TutorialVideo as TutorialVideoType } from "@app/_metadata";
import Image from "next/image";
export function TutorialVideo(t0) {
  const $ = _c(9);
  const {
    video
  } = t0;
  let t1;
  if ($[0] !== video.thumbnail || $[1] !== video.title) {
    t1 = <div className="overflow-hidden rounded-lg border border-black/10"><Image src={video.thumbnail} alt={video.title} className="aspect-video w-full object-cover" width={600} height={338} /></div>;
    $[0] = video.thumbnail;
    $[1] = video.title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="pointer-events-none absolute inset-0 rounded-lg outline outline-offset-2 outline-black/40 opacity-0 transition-opacity group-hover:opacity-100" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <div className="relative">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3 || $[7] !== video.url) {
    t4 = <a href={video.url} target="_blank" rel="noopener noreferrer" className="group">{t3}</a>;
    $[6] = t3;
    $[7] = video.url;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}